import { IntegrityMonitorCustomRuleBaseDataProvider } from './IntegrityMonitorCustomRuleBaseDataProvider';
import { sanitizeObject } from '../../../../../utils/sanitization.utils';

export class IntegrityMonitorCustomRuleGzDataProvider extends IntegrityMonitorCustomRuleBaseDataProvider {
  public async createCustomRule(record: Object): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRules.createCustomRule(record).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async updateCustomRule(record: Object): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRules.updateCustomRule(record).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async assignRulesToRuleSets(
    companyId: string,
    ruleIds: Array<string>,
    ruleSetIds: Array<string>
  ): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorRuleSets.assignRulesToRuleSets(
        companyId,
        ruleIds,
        ruleSetIds
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
